import { Link } from "react-router-dom";
import { LOGO_URL, STORE, UBER_EATS_URL } from "@/config/site";
import { Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] border-t border-white/10 pt-14 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <img
              src={LOGO_URL}
              alt="Smashed Burger & Bao Boy"
              className="h-16 w-auto mb-4"
              loading="lazy"
            />
            <p className="font-body text-white/55 text-sm leading-relaxed">
              Smashed burgers &amp; fresh baos. Built fresh in Hove, delivered hot.
            </p>
          </div>

          <div>
            <h4 className="font-subheading font-bold uppercase tracking-widest text-white text-xs mb-4">
              Visit
            </h4>
            <p className="font-body text-white/65 text-sm leading-relaxed">
              {STORE.address_line1}<br />{STORE.address_line2}
            </p>
            <a
              href={STORE.phone_tel}
              data-testid="footer-phone-link"
              className="block mt-3 font-body text-white/65 hover:text-brand-orange text-sm"
            >
              {STORE.phone}
            </a>
          </div>

          <div>
            <h4 className="font-subheading font-bold uppercase tracking-widest text-white text-xs mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2 font-body text-sm">
              <li><a href="#menu" data-testid="footer-link-menu" className="text-white/65 hover:text-brand-orange">Menu</a></li>
              <li><a href="#location" data-testid="footer-link-location" className="text-white/65 hover:text-brand-orange">Location &amp; Hours</a></li>
              <li><a href="#about" data-testid="footer-link-about" className="text-white/65 hover:text-brand-orange">About Us</a></li>
              <li>
                <a
                  href={UBER_EATS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-link-order"
                  className="text-brand-orange font-semibold hover:underline"
                >
                  Order Delivery
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-subheading font-bold uppercase tracking-widest text-white text-xs mb-4">
              Legal
            </h4>
            <ul className="space-y-2 font-body text-sm">
              <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-white/65 hover:text-brand-orange">Privacy Policy</Link></li>
              <li><Link to="/cookies" data-testid="footer-link-cookies" className="text-white/65 hover:text-brand-orange">Cookie Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-link-terms" className="text-white/65 hover:text-brand-orange">Terms of Service</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-instagram"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-brand-orange/20 text-white/70 hover:text-brand-orange flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-facebook"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-brand-orange/20 text-white/70 hover:text-brand-orange flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-white/40 text-xs font-body">
          <span>© {new Date().getFullYear()} Smashed Burger &amp; Bao Boy. All rights reserved.</span>
          <span>Hove, UK · Take-away &amp; Delivery</span>
        </div>
      </div>
    </footer>
  );
}
